module.exports = __webpack_public_path__ + "d6b298e5.svg";